(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureModifierDeleteController',ProcedureModifierDeleteController);

    ProcedureModifierDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProcedureModifier'];

    function ProcedureModifierDeleteController($uibModalInstance, entity, ProcedureModifier) {
        var vm = this;

        vm.procedureModifier = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProcedureModifier.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
